import React from "react";

export default function ObjetLaboratoire({ laboratoire }) {
  return <div>{laboratoire?.nom}</div>;
}
